import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  marginTop: {
    marginTop: "10px",
  },
  terms: {
    // maxWidth: "300px",
  },
  label: {
    marginTop: 10,
    fontSize: "12px",
    whiteSpace: "normal",
    [theme.breakpoints.up("xl")]: {
      lineHeight: "25px",
      marginTop: 2,
      fontSize: "12px",
      maxWidth: "100%",
      width: "19vw",
    },
    maxWidth: "300px",
    display: "flex",
    lineHeight: "15px",
    fontWeight: 450,
  },
  termLabel: {
    fontSize: "12px",
    whiteSpace: "normal",
    [theme.breakpoints.up("xl")]: {
      lineHeight: "25px",
      fontSize: "12px",
      maxWidth: "100%",
    },
    maxWidth: "300px",
    display: "inline-block",
    lineHeight: "15px",
    fontWeight: 450,
  },
  link: {
    color: "#0d6efd",
    cursor: "pointer",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));
export default useStyles;
